import { resolveLanguageCode } from './locale';

const FALLBACK_LOCALE = 'en';
const PDF_CHROME_LABELS = {
  en: {
    projectLabel: 'AGRIVOLTAIC PROJECT',
    reportTitle: 'Agronomic report',
    pageLabel: 'Page',
    ofLabel: 'of',
  },
  it: {
    projectLabel: 'PROGETTO AGROVOLTAICO',
    reportTitle: 'Relazione agronomica',
    pageLabel: 'Pag.',
    ofLabel: 'di',
  },
  es: {
    projectLabel: 'PROYECTO AGROVOLTAICO',
    reportTitle: 'Informe agronómico',
    pageLabel: 'Pág.',
    ofLabel: 'de',
  },
};

const getCoverBlock = (templateDocument) => (
  (templateDocument?.sections || [])
    .flatMap(section => section?.blocks || [])
    .find(block => block?.type === 'cover')
);

export const normalizePdfHeaderProject = ({ reportPayload, reportId, locale = FALLBACK_LOCALE }) => {
  const languageCode = resolveLanguageCode(locale, FALLBACK_LOCALE);
  const projectLabel = PDF_CHROME_LABELS[languageCode]?.projectLabel || PDF_CHROME_LABELS[FALLBACK_LOCALE].projectLabel;
  const projectName = reportPayload?.name || reportPayload?.projectName || reportId || '';
  return `${projectLabel} ${projectName}`.trim();
};

export const normalizePdfHeaderReportTitle = ({ templateDocument, locale = FALLBACK_LOCALE }) => {
  const languageCode = resolveLanguageCode(locale, FALLBACK_LOCALE);
  const coverBlock = getCoverBlock(templateDocument);
  if (coverBlock?.title) {
    return coverBlock.title;
  }
  return PDF_CHROME_LABELS[languageCode]?.reportTitle || PDF_CHROME_LABELS[FALLBACK_LOCALE].reportTitle;
};

export const resolvePdfPageLabels = (locale = FALLBACK_LOCALE) => {
  const languageCode = resolveLanguageCode(locale, FALLBACK_LOCALE);
  const labels = PDF_CHROME_LABELS[languageCode] || PDF_CHROME_LABELS[FALLBACK_LOCALE];
  return {
    pageLabel: labels.pageLabel,
    ofLabel: labels.ofLabel,
  };
};

export const buildPdfChromeMetadata = ({
  reportPayload,
  reportId,
  templateDocument,
  locale = FALLBACK_LOCALE,
}) => ({
  headerLeft: normalizePdfHeaderProject({
    reportPayload,
    reportId,
    locale,
  }),
  headerRight: normalizePdfHeaderReportTitle({
    templateDocument,
    locale,
  }),
  ...resolvePdfPageLabels(locale),
});
